var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container settings"},[_c('h2',[_vm._v("Settings")]),_c('b-button',{staticClass:"mt-3",attrs:{"variant":"primary"},on:{"click":_vm.clearCache}},[_vm._v("Clear Cache")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }